export default "__VITE_PUBLIC_ASSET__8c02af2f__"